<template>
	<v-popover trigger='hover click' placement='top' popoverClass='a-price-popover' class='a-price-info'>
		<button type='button' class='a-price-info-btn'>
			<v-icon icon='info' size='14' />
		</button>
		<template slot='popover'>
			<div class='a-price-popover-row a-price-popover-total'>
				<span>{{$t('account.result.price_for_client')}}</span>
				<b>{{$helpers.amount(offer.amount, offer.currency)}}</b>
			</div>
			<template v-if='offer.agentAmount'>
				<div class='a-price-popover-row'>
					<span>{{$t('account.result.price_for_agent')}}</span>
					<b>{{$helpers.amount(offer.agentAmount, offer.currency)}}</b>
				</div>
				<div class='a-price-popover-row' v-if='agentMarkup > 0'>
					<span>{{$t('account.result.agent_markup')}}</span>
					<span>{{$helpers.amount(agentMarkup, offer.currency)}}</span>
				</div>
			</template>
			<template v-if='night'>
				<div class='a-price-popover-divider'></div>
				<p class='a-price-popover-title'>{{$t('account.result.price_per_night')}}</p>
				<div class='a-price-popover-row'>
					<span>{{$t('account.result.for_client')}}</span>
					<span>{{$helpers.amount(offer.amount / night, offer.currency)}}</span>
				</div>
				<div class='a-price-popover-row' v-if='offer.agentAmount'>
					<span>{{$t('account.result.for_agent')}}</span>
					<span>{{$helpers.amount(offer.agentAmount / night, offer.currency)}}</span>
				</div>
			</template>
		</template>
	</v-popover>
</template>

<script>
	// Иконка «i» у цены отеля: цена для клиента и агента, наценка агента, цена за ночь.
	// offer.amount — цена для клиента, offer.agentAmount — без наценки агента (считает бэкенд).
	export default {
		props: ['offer', 'night'],
		computed: {
			agentMarkup() {
				return this.offer.agentAmount ? this.offer.amount - this.offer.agentAmount : 0;
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/global/variables";

	.a-price-info {
		display: inline-flex;
		margin-left: 8px;
		&-btn {
			display: flex;
			padding: 0;
			border: none;
			background: none;
			color: rgba($black, .4);
			cursor: pointer;
			transition: color $transition;
			&:hover {
				color: $green-persian;
			}
		}
	}

	// Переопределяет базовый .tooltip (текст по центру, узкие отступы).
	.tooltip.a-price-popover {
		text-align: left;
		padding: 12px 16px;
		min-width: 240px;
		.a-price-popover-row {
			display: flex;
			justify-content: space-between;
			gap: 20px;
			&:not(:last-child) {
				margin-bottom: 4px;
			}
		}
		.a-price-popover-total {
			font-size: 14px;
		}
		.a-price-popover-title {
			font-weight: 600;
			margin-bottom: 4px;
		}
		.a-price-popover-divider {
			height: 1px;
			margin: 10px 0;
			background-color: rgba($white, .2);
		}
	}
</style>
